module.exports = __webpack_public_path__ + "static/media/2018-visit-unilag.ec5ce255.md";


//////////////////
// WEBPACK FOOTER
// ./src/Pages/Experiences/Contents/2018-visit-unilag.md
// module id = 1078
// module chunks = 0